<template>
	<div>
		<p>На этой странице находятся краткие руководства приложения.</p>
		<el-collapse v-model="activeNames">
			<el-collapse-item title="С чего начать?" name="1">
			    <ol>
					<li v-if="!isLogin">Нажмите на кнопку "Войти", которая находится в левом меню.</li>
					<li v-if="isLogin">Чтобы добавить первый предмет в Вашу коллекцию перейдите на вкладку <router-link to="/item-base">"База предметов".</router-link></li>
					<li v-if="isLogin">Нажмите на кнопку "Добавить", находящуюся в правом углу ряда с предметом. Если предмет уже находится в коллекции, то вместо кнопки "Добавить" будет находится кнопка "Редактировать".</li>
					<li v-if="isLogin">Добавленные Вами предметы будут доступны на странице <router-link to="/items">"Коллекция предметов"</router-link>.</li>
		    	</ol>
			</el-collapse-item>
			<el-collapse-item v-if="isLogin" title="Настройка для сервера PowerCraft" name="2">
				<!-- <p>Для максимально ускоренного предпросмотра приложения, на примере расчёта минимальных цен предметов для некоторых модификаций сервера Power Craft проекта MinecraftOnly. Расчёт сделал именно на основе базовых ресурсов из таблицы "Основное" с соответствующей <a href="https://minecraftonly.ru/forum/showthread.php?335226-%D0%9C%D0%B8%D0%BD%D0%B8%D0%BC%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B5-%D1%86%D0%B5%D0%BD%D1%8B-%D1%81%D0%B5%D1%80%D0%B2%D0%B5%D1%80%D0%B0-PowerCraft" target="_blank" rel="nofollow">страницы форума</a>. Цены готовых предметов из таблиц ниже в текущем расчёте проигнорированы.</p>
				<p><b>Первый способ:</b></p> -->
				<ol>
					<!-- <li>Нажмите на кнопку "Войти", которая находится в левом меню.</li> -->
					<li>Перейдите на <router-link to="/export-items">вкладку "Экспорт предметов"</router-link>.</li>
					<li>Укажите в поле "Коллекция" значение "PowerCraft".</li>
					<li>Укажите в поле "Модификация" значение "Все модификации".</li>
					<li>Скопируйте значение из поля "JSON".</li>
					<li>Перейдите на <router-link to="/import-items">вкладку "Импорт предметов"</router-link>.</li>
					<li>В поле "Модификация" укажите значение "Все модификации".</li>
					<li>Вставьте в поле "JSON" значение, скопированное ранее из поля "JSON" на вкладке "Экспорт предметов".</li>
					<!-- <li>В поле "JSON" вставьте настройки предметов для сервера "Power Craft" из <a href="https://firebasestorage.googleapis.com/v0/b/elements-239920.appspot.com/o/uploads%2F2019%2F09%2FpowerCraftSettings.json?alt=media&token=69c6272c-e7e9-4f4b-b0cf-a0c1a3e9d5c2" target="_blank" rel="nofollow">этого файла</a> формата <a href="https://ru.wikipedia.org/wiki/JSON" target="_blank" rel="nofollow"><b>JSON</b></a>.</li> -->
					<li>Нажмите на кнопку "Импортировать".</li>
					<!-- <li>Для просмотра стоимостей предметов перейдите на <router-link to="/items">вкладку "Коллекция предметов"</router-link></li> -->
				</ol>
				<p>Импорт предметов может занять минуту, по его окончанию в левом меню в пункте "Коллекция предметов" отобразится текущее количество предметов в коллекции, примерно 597 штук. Это далеко не все предметы, стоимость которых можно рассчитать для сервера, а лишь те, которые я успел настроить на текущий момент. Далее Вы можете настроить другие, интересующие Вас предметы, которые имеются в базе или же исправить настройки текущих предметов под себя, так как со временем минимальная цена предметов на сервере меняется.</p>
				<!-- <p><b>Второй способ:</b></p>
			    <ol>
					<li>Перейдите по <router-link to="/express-preview">этой ссылке</router-link>, вышеизложенные шаги выполнятся автоматически</li>
		    	</ol> -->
			</el-collapse-item>
		</el-collapse>
	</div>	
</template>

<script>
export default {
  	data() {
	    return {
	    	activeNames: ['1', '2',],
	    };
  	},
  	computed: {
  		isLogin(){
  			var self = this;
  			return self.$store.state.user ? true : false;
  		},
  	},
};
</script>
